<template>
  <div class="gardenPlotHome">
    <!-- <div class="gardenPlot-title">论坛和沙龙</div> -->
    <div class="gardenPlot-list">
      <router-link
        v-for="(item, index) in list"
        :key="index"
        class="gardenPlot-item"
        tag="div"
        :to="{
          path: 'gardenPlot/details',
          query: { id: item.id }
        }"
      >
        <div class="gardenPlot-img">
          <el-image :src="item.cover" fit="fill"></el-image>
        </div>
        <div class="gardenPlot-right">
          <div class="gardenPlot-r-title">{{ item.title }}</div>
          <div class="gardenPlot-time">{{ item.publishDate | timeData }}</div>
        </div>
      </router-link>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pags.total"
      :page-size.sync="pags.pageSize"
      class="pageBox"
      :pager-count="5"
      @current-change="changePage"
    ></el-pagination>
    <div class="he50"></div>
  </div>
</template>
<script>
import { newsGetNewsList } from "@/api/api.js";

export default {
  data() {
    return {
      pags: {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        categoryId: 3
      },
      list: []
    };
  },
  mounted() {
    this.newsGetNewsList();
  },
  methods: {
    changePage(val) {
      this.pags.pageNum = val;
      this.newsGetNewsList();
    },
    newsGetNewsList() {
      newsGetNewsList(this.pags).then(res => {
        if (res.code === 0) {
          this.list = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>
<style lang="less">
.gardenPlotHome {
  width: 100%;
  padding: 0 20px 20px;
  box-sizing: border-box;
  // .gardenPlot-title {
  //   font-size: 14px;
  //   color: #343434;
  //   letter-spacing: 0;
  //   text-align: justify;
  //   line-height: 14px;
  //   font-weight: bold;
  // }
  .gardenPlot-list {
    // margin-top: 20px;
    .gardenPlot-item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: 1px solid #f0f0f0;
      .gardenPlot-img {
        overflow: hidden;
        width: 130px;
        height: 90px;
        background: #5e5e5e;
        border-radius: 2px;
        border-radius: 2px;
      }
      .gardenPlot-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: calc(100% - 140px);
        .gardenPlot-r-title {
          font-size: 14px;
          color: #141414;
          text-align: justify;
        }
        .gardenPlot-time {
          font-size: 12px;
          color: #999999;
          text-align: justify;
          line-height: 12px;
        }
      }
    }
  }
  .pageBox {
    text-align: center;
    margin: 30px auto 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0f4581;
  }
}
</style>
